'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promoCodes = require('./promoCodes');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_promoCodes).default;
  }
});

var _model = require('./model');

Object.defineProperty(exports, 'PromoDataRecord', {
  enumerable: true,
  get: function get() {
    return _model.PromoDataRecord;
  }
});
Object.defineProperty(exports, 'PromoDataRecordType', {
  enumerable: true,
  get: function get() {
    return _model.PromoDataRecordType;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/data-provider/dist/main/promo-codes/index.js
// module id = 454
// module chunks = 0